import axios, { AxiosInstance, AxiosResponse } from "axios";
import { GraphPredictionResponse, PredictionsCardResponse, RiderCategoryStatsResponse, ZyppAgeStatsResponse } from "../../../@Types/DRO/ChurnApiResponse/GraphPredictionResponse";


export class PredictionGraphApi {
  public static api = new PredictionGraphApi();
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_CHURN_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getToken() {
   return localStorage.getItem("token");
  }
  async getChurnPercentGraph(): Promise<GraphPredictionResponse> {
    try {
      const response: AxiosResponse<GraphPredictionResponse> =
        await this.instance.get("/churn-percent-graph/", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching churn percent graph data", error);
      throw error;
    }
  }
  async getPredictionsCards(
    start_date: string,
    end_date: string
  ): Promise<PredictionsCardResponse> {
    try {
      const response: AxiosResponse<PredictionsCardResponse> =
        await this.instance.get("/predictions-cards/", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date,
            end_date,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions cards data", error);
      throw error;
    }
  }
  
  async getZyppAgeStats(
    start_date: string,
    end_date: string
  ): Promise<ZyppAgeStatsResponse> {
    try {
      const response: AxiosResponse<ZyppAgeStatsResponse> =
        await this.instance.get("/zypp-age-stats", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date,
            end_date,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions cards data", error);
      throw error;
    }
  }

  async getRiderCategoryStats(
    start_date: string,
    end_date: string
  ): Promise<RiderCategoryStatsResponse> {
    try {
      const response: AxiosResponse<RiderCategoryStatsResponse> =
        await this.instance.get("/category-stats", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            start_date,
            end_date,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions cards data", error);
      throw error;
    }
  }
}
